import { Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  subHeading1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#000000",
    fontWeight: 400,
    alignItems: "center",
    fontSize: "1rem",
    lineHeight: "1.688rem",
    margin: "0.5rem 0rem 0rem 0rem",
  },
  subHeading: {
    fontSize: "1rem",
    lineHeight: "1.688rem",
    color: "#212121",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.25rem",
    },
  },
}));

const SchoolVicinity = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Detect mobile devices

  const schools = [
    { name: "St.Peter's School", distance: "0.65 KM" },
    { name: "Asia Pacific World School", distance: "1.5 KM" },
    { name: "Orchids The International School", distance: "3.7 KM" },
    { name: "New Horizon College of Engineering", distance: "6 KM" },
    { name: "Delhi Public School, Bangalore East", distance: "7 KM" },
    { name: "Azim Premji University", distance: "7 KM" },
    { name: "Oakridge International School", distance: "9.2 KM" },
  ];

  const displayedSchools = isMobile ? schools.slice(0, 4) : schools;

  return (
    <React.Fragment>
      {displayedSchools.map((school, index) => (
        <div className={classes.subHeading1} key={index}>
          <Typography className={classes.subHeading}>{school.name}</Typography>
          <Typography className={classes.subHeading}>{school.distance}</Typography>
        </div>
      ))}
    </React.Fragment>
  );
};

export default SchoolVicinity;
